import React from "react";

import "./Contents.scss";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function Contents({ children, className, ...props }: IProps) {
    const classNames = ["userful-contents", className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
